<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/material/bom/page" :columns="columns" getKey="rows">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzengBOM', null, 'w2')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chakanBOM', scope.row, 'w2')">{{ $t('chakan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit)">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/material/bom/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('wuliaoshuxing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.code">
              <el-option value="1" label="yanse"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shuxingzhi')">
            <yi_dictionary_select :type="'CUSTOMER_MATERIAL_P0ROPERTY_VALUE'" :ids.sync="yt.editObj.value"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/material/bom/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <matter_edit :edit="edit" ref="matterEdit" :matterRow="row"></matter_edit>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="submitEditMaterialBom" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 物料BOM新增 -->
      <template v-if="yt.editObj.action == 'xinzengBOM'">
        <div class="dialog-scroller">
          <matter_add :add="yt.editObj" ref="matterAdd" :matterRow="row"></matter_add>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="submitAddMaterialBom" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 查看 -->
      <template v-if="yt.editObj.action == 'chakanBOM'">
        <div class="dialog-scroller">
          <check_bom :check="yt.editObj"></check_bom>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import check_bom from '@@/pages/web/base/matter/check_bom';
import matter_add from '@@/pages/web/base/matter/matter_add';
import matter_edit from '@@/pages/web/base/matter/matter_edit';
export default {
  name: 'web_base_matter_matter_bom',
  components: {
    check_bom,
    matter_add,
    matter_edit
  },
  data() {
    return {
      columns: [
        {
          label: 'wuliaoBOMmingcheng',
          prop: 'name',
          width: 130
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'shifoumoren',
          prop: 'isDefault',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 160
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ],
      edit: {}
    };
  },
  props: {
    row: {
      type: [Object]
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        // materialId: this.$attrs.bom.id,
        materialId: this.row.id,
        pageSize: 1999
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300);
  },

  methods: {
    //深拷贝
    deepClone(data) {
      console.log('dataaaa', data);
      let obj = this.utils.copy(data);
      // console.log("data2:",data)
      // const type = this.judgeType(data);
      // let obj;
      // if (type === 'array') {
      // 	obj = [];
      // } else if (type === 'object') {
      // 	obj = {};
      // } else {
      // 	// 不再具有下一层次
      // 	return data;
      // }
      // if (type === 'array') {
      // 	// eslint-disable-next-line
      // 	for (let i = 0, len = data.length; i < len; i++) {
      // 		obj.push(this.deepClone(data[i]));
      // 	}
      // } else if (type === 'object') {
      // 	// 对原型上的方法也拷贝了....
      // 	// eslint-disable-next-line
      // 	for (const key in data) {
      // 		obj[key] = this.deepClone(data[key]);
      // 	}
      // }
      console.log('obj:', obj);
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    beforeEdit(params) {
      // 深拷贝
      // const data = JSON.parse(JSON.stringify(row))
      console.log('data11223', params);
      // for (let i = 0; i < params['items'].length; i++) {
      // 	params['items'][i]['weight'] = params['items'][i][
      // 		'weight'
      // 	] / 1000
      // }

      this.edit = params;

      return params;
    },
    // 新增物料BOM
    submitAddMaterialBom() {
      // this.yt.isShowEditDialog = false;
      const res = this.$refs['matterAdd'].$refs['form'].validate(valid => {
        if (!valid) {
          return false;
        }

        let form = this.$refs['matterAdd'].form;
        for (let i = 0; i < form['items'].length; i++) {
          console.log('weight:', form['items'][i]['weight']);

          // form['items'][i]['weight'] = form['items'][i]['weight'] * 1000;
          // 新增属性保存原始值
          form['items'][i]['originalWeight'] = form['items'][i]['weight'];
          console.log('addBOM:', form['items'][i]['weight']);
        }
        form['materialId'] = this.row.id;
        return this.http
          .post('/web/material/bom/create', form)
          .then(response => {
            this.yt.get(1);
            this.yt.isShowEditDialog = false;
          })
          .catch(error => {
            for (let j = 0; j < form['items'].length; j++) {
              form['items'][j]['weight'] = form['items'][j]['originalWeight'];  // 利用原始值还原
            }

            this.$message.error(error);
          });
      });
    },
    // 更新物料BOM
    submitEditMaterialBom() {
      const res = this.$refs['matterEdit'].$refs['form'].validate(valid => {
        if (!valid) {
          return false;
        }
        let form = this.$refs['matterEdit'].form;
        for (let i = 0; i < form['items'].length; i++) {
          let ratio = form['items'][i]['ratio'];
          if (ratio == null || ratio == undefined) {
            form['items'][i]['ratio'] = 0;
          }
        }
        return this.http
          .post('/web/material/bom/update', form)
          .then(res => {
            this.yt.get(1);
            this.yt.isShowEditDialog = false;
			this.$message.success(this.$t(res.msg));
          })
          .catch(error => {
            this.$message.error(error);
          });
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
